import { getRegion } from '../helpers/config';
import { fetchWithToken } from '../token/fetchWithToken';

export const fetchWithTokenAndRegion = <T>(
  url: RequestInfo,
  fetchData?: RequestInit,
) => {
  const mergedFetchData = {
    ...fetchData,
    headers: {
      ...(fetchData && fetchData.headers),
      Region: getRegion(),
    },
  };
  return fetchWithToken<T>(url, mergedFetchData);
};
